var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Reply',{key:_vm.company,attrs:{"url":_vm.url}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }